import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {RelatedEntitiesFactory} from "./related-entities-factory";
import {RelatedEntitiesRepository} from "./related-entities-repository";

export class RelatedEntitiesDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, RelatedEntitiesRepository, RelatedEntitiesFactory, DomainRequestManager];

}
